if (!customElements.get('mthr-flip-card')) {
  customElements.define('mthr-flip-card', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const button = this.querySelector('button');
      const front = this.querySelector('.mthr-flip__front');
      const back = this.querySelector('.mthr-flip__back');
      const setFlipped = flipped => {
        this.classList.toggle('is-flipped', flipped);
        button.setAttribute('aria-expanded', String(flipped));
        button.setAttribute('aria-label', `${flipped ? 'Back to image' : 'Show benefits'}: ${button.dataset.title}`);
        front.setAttribute('aria-hidden', String(flipped));
        back.setAttribute('aria-hidden', String(!flipped));
        back.inert = !flipped;
      };
      setFlipped(false);
      button.addEventListener('click', () => setFlipped(!this.classList.contains('is-flipped')), {signal:this.controller.signal});
      this.addEventListener('keydown', event => { if (event.key === 'Escape') { setFlipped(false); button.focus(); } }, {signal:this.controller.signal});
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
